import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/i18n/ui.js'
import store from '@/store/store'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.getters['setting/getLanguage'],
  fallbackLocale: process.env.VUE_APP_LANG,
  messages,
})

export default i18n
